import React from "react";
import { PageHeading } from "components/common";
import { useTranslation } from "react-i18next";
import { default as PrivacyTextBg } from "locales/bg/PrivacyText";
import { default as PrivacyTextEn } from "locales/en/PrivacyText";
import { Box } from "@material-ui/core";
import { useStyles } from "styling/mainStyles";
import { EN, BG } from "translation";
import { useLocale } from "hooks";

const Privacy = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { localeState } = useLocale();

  return (
    <>
      <PageHeading>{t("privacyPolicy")}</PageHeading>
      <Box className={classes.pageText}>
        {localeState.locale === EN ? <PrivacyTextEn /> : <PrivacyTextBg />}
      </Box>
    </>
  );
};

export default Privacy;
